import React from "react";
import Slider from "react-slick";

function Whatpeoplesay() {
  var settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    initialSlide: 0,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  return (
    <>
      <div className="what-people-slider">
        <div className="what-people-slider">
          <Slider {...settings}>
            <div className="what-people-slide">
              <div className="what-people-dv">
              <div className="span-line-head">
                  <span className="extra-color-5">Reviews</span>
                </div>
                <h2 className="primary-color">What People Say About Us</h2>
                <p>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                  do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                  Ut enim ad minim veniam, quis nostrud exercitation ullamco
                  laboris nisi ut aliquip ex ea commodo consequat. Lorem ipsum
                  dolor sit amet, consectetur adipiscing elit, sed do eiusmod
                  tempor incididunt ut labore et dolore magna aliqua. Ut enim ad
                  minim veniam, quis nostrud exercitation ullamco laboris nisi
                  ut aliquip ex ea commodo consequat.{" "}
                </p>
                <h3 className="primary-color">John Williams</h3>
                <h5 className="extra-color-5">Founder & Ceo Powerfulhand</h5>
              </div>
            </div>
            <div className="what-people-slide">
              <div className="what-people-dv">
              <div className="span-line-head">
                  <span className="extra-color-5">Reviews</span>
                </div>
                <h2 className="primary-color">What People Say About Us</h2>
                <p>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                  do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                  Ut enim ad minim veniam, quis nostrud exercitation ullamco
                  laboris nisi ut aliquip ex ea commodo consequat. Lorem ipsum
                  dolor sit amet, consectetur adipiscing elit, sed do eiusmod
                  tempor incididunt ut labore et dolore magna aliqua. Ut enim ad
                  minim veniam, quis nostrud exercitation ullamco laboris nisi
                  ut aliquip ex ea commodo consequat.{" "}
                </p>
                <h3 className="primary-color">John Williams</h3>
                <h5 className="extra-color-5">Founder & Ceo Powerfulhand</h5>
              </div>
            </div>
            <div className="what-people-slide">
              <div className="what-people-dv">
              <div className="span-line-head">
                  <span className="extra-color-5">Reviews</span>
                </div>
                <h2 className="primary-color">What People Say About Us</h2>
                <p>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                  do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                  Ut enim ad minim veniam, quis nostrud exercitation ullamco
                  laboris nisi ut aliquip ex ea commodo consequat. Lorem ipsum
                  dolor sit amet, consectetur adipiscing elit, sed do eiusmod
                  tempor incididunt ut labore et dolore magna aliqua. Ut enim ad
                  minim veniam, quis nostrud exercitation ullamco laboris nisi
                  ut aliquip ex ea commodo consequat.{" "}
                </p>
                <h3 className="primary-color">John Williams</h3>
                <h5 className="extra-color-5">Founder & Ceo Powerfulhand</h5>
              </div>
            </div>
            <div className="what-people-slide">
              <div className="what-people-dv">
                <div className="span-line-head">
                  <span className="extra-color-5">Reviews</span>
                </div>
                <h2 className="primary-color">What People Say About Us</h2>
                <p>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                  do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                  Ut enim ad minim veniam, quis nostrud exercitation ullamco
                  laboris nisi ut aliquip ex ea commodo consequat. Lorem ipsum
                  dolor sit amet, consectetur adipiscing elit, sed do eiusmod
                  tempor incididunt ut labore et dolore magna aliqua. Ut enim ad
                  minim veniam, quis nostrud exercitation ullamco laboris nisi
                  ut aliquip ex ea commodo consequat.{" "}
                </p>
                <h3 className="primary-color">John Williams</h3>
                <h5 className="extra-color-5">Founder & Ceo Powerfulhand</h5>
              </div>
            </div>
            <div className="what-people-slide">
              <div className="what-people-dv">
              <div className="span-line-head">
                  <span className="extra-color-5">Reviews</span>
                </div>
                <h2 className="primary-color">What People Say About Us</h2>
                <p>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                  do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                  Ut enim ad minim veniam, quis nostrud exercitation ullamco
                  laboris nisi ut aliquip ex ea commodo consequat. Lorem ipsum
                  dolor sit amet, consectetur adipiscing elit, sed do eiusmod
                  tempor incididunt ut labore et dolore magna aliqua. Ut enim ad
                  minim veniam, quis nostrud exercitation ullamco laboris nisi
                  ut aliquip ex ea commodo consequat.{" "}
                </p>
                <h3 className="primary-color">John Williams</h3>
                <h5 className="extra-color-5">Founder & Ceo Powerfulhand</h5>
              </div>
            </div>
          </Slider>
        </div>
      </div>
    </>
  );
}

export default Whatpeoplesay;
